export { default as JobParameters } from "./JobParameters";

// functions for mounting job parameters display in non-Vue environments
export { mountJobParameters } from "./mount";
